// ----------------------------------------------------------------------

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1440,
    xl: 1900,
  },
};

export default breakpoints;
